// All dates/times displayed in the app use Pacific time (PST/PDT).
export const PST_TZ = 'America/Los_Angeles';

const pstOptions = (opts = {}) => ({ timeZone: PST_TZ, ...opts });

export function formatDateTime(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleString(undefined, pstOptions({ dateStyle: 'short', timeStyle: 'short' }));
}

export function formatDateOnly(dateString, options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString(undefined, pstOptions(options));
}

export function formatTimeOnly(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleTimeString(undefined, pstOptions({ hour: '2-digit', minute: '2-digit' }));
}

export function formatExpireDate(dateString) {
  if (!dateString) return '';
  const datePart = (dateString + '').slice(0, 10);
  return new Date(datePart + 'T12:00:00').toLocaleDateString(undefined, pstOptions({ year: 'numeric', month: 'short', day: 'numeric' }));
}

export function formatExpireDateShort(dateString) {
  if (!dateString) return '—';
  const datePart = (dateString + '').slice(0, 10);
  return new Date(datePart + 'T12:00:00').toLocaleDateString(undefined, pstOptions({ dateStyle: 'short' }));
}

/** Today's date in PST as YYYY-MM-DD (for expiry comparison: valid through end of expire_date). */
export function getTodayPST() {
  return new Date().toLocaleDateString('en-CA', { timeZone: PST_TZ });
}
